module.exports = __webpack_public_path__ + "img/login_logo.2eb9a358.png";